import { Link } from 'react-router-dom';
import { ReleaseDetails } from '@reflex/ui/components/content/ReleaseContent';
import type { ReleaseEventPayload } from '../../../shared/types.js';

export interface ReleaseEventRendererProps {
  payload: ReleaseEventPayload;
}

/**
 * Renders a release-event notification body via the shared `ReleaseDetails`:
 * an overview + "Highlights" summary, optional high-level features (each
 * deep-linking its tutorials), case-study cards, and the changelog entry (with
 * a "Show more" toggle when long). When a release has no authored content it
 * shows a short release-type-driven note instead, and the changelog section is
 * omitted entirely for an authored release that has no matching `CHANGELOG.md`
 * entry yet. The release-type badge and version live in the surrounding
 * notification header (see `NotificationContent` / `ReleaseGroupContent`), so
 * they are intentionally not repeated here. `payload.changelogUrl` is not
 * rendered — the releases page it points at is generated from a private repo,
 * so the link out is hidden for now. The releases page renders the same
 * `ReleaseDetails`, so the two surfaces stay identical.
 */
export function ReleaseEventRenderer({ payload }: ReleaseEventRendererProps) {
  return (
    <ReleaseDetails
      releaseType={payload.releaseType}
      title={payload.title}
      overview={payload.overview}
      highlights={payload.highlights}
      features={payload.features}
      caseStudies={payload.caseStudies}
      changelogSummary={payload.changelogSummary}
      linkComponent={Link}
      data-testid="notification-renderer-release-event"
    />
  );
}
